import { ReactElement } from 'react'
import React from 'react'

import { LayoutProps } from '../types'
import { Layout } from '../ui'

export const getDefaultLayout = function (layoutProps: Omit<LayoutProps, 'children'> = {}) {
	return (page: ReactElement) => <Layout {...layoutProps}>{page}</Layout>
}

export const getLayout = function (
	Element: (...props: any) => ReactElement,
	layoutProps: Omit<LayoutProps, 'children'> = {}
) {
	return (page: ReactElement) => <Element {...layoutProps}>{page}</Element>
}

export const getDefaultLayoutDynamic = function (getLayoutProps: () => Omit<LayoutProps, 'children'>) {
	return (page: ReactElement) => <Layout {...getLayoutProps()}>{page}</Layout>
}
